export default class FormValidationClass {
    constructor(formId) {
        this.formId = formId;
        this.form = document.getElementById(formId);
    }

    // Validates all required fields
    init() {
        let isValid = true;
        const requiredFields = this.form.querySelectorAll('.required');
        requiredFields.forEach(field => {
            if (!field.value || field.value.trim() === '') {
                this.addErrorClass(field);
                isValid = false;
            } else {
                this.removeErrorClass(field);
            }
        });
        return isValid;
    }

    // Adds an error class to a field
    addErrorClass(field) {
        field.closest('.js-input-validation').classList.add('has-error');
    }

    // Removes an error class from a field
    removeErrorClass(field) {
        field.closest('.js-input-validation').classList.remove('has-error');
    }
}
